import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";
import { IconButton } from "./Button";

const ICONS = { success: CheckCircle2, danger: AlertCircle, info: Info };

export function ToastViewport({ toasts, dismiss }) {
  return (
    <div className="toast-viewport" aria-live="polite">
      {toasts.map((toast) => {
        const Icon = ICONS[toast.tone] || Info;
        return (
          <div className={`toast toast--${toast.tone || "info"}`} key={toast.id}>
            <Icon size={18} />
            <div>
              <strong>{toast.title}</strong>
              {toast.message ? <p>{toast.message}</p> : null}
            </div>
            <IconButton size="sm" icon={X} label="关闭通知" onClick={() => dismiss(toast.id)} />
          </div>
        );
      })}
    </div>
  );
}
